import EditDetails from './EditDetails'
import enhance from './EditDetails.enhancer'

export default enhance(EditDetails)



// WEBPACK FOOTER //
// ./src/containers/account/EditDetails/index.js